'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _resource = require('../resource');

var _resource2 = _interopRequireDefault(_resource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Certifications = function (_Resource) {
    (0, _inherits3.default)(Certifications, _Resource);

    function Certifications() {
        (0, _classCallCheck3.default)(this, Certifications);
        return (0, _possibleConstructorReturn3.default)(this, (Certifications.__proto__ || (0, _getPrototypeOf2.default)(Certifications)).apply(this, arguments));
    }

    (0, _createClass3.default)(Certifications, [{
        key: 'delete',

        /**
         * @api {delete} /v1/certifications/:certification_id delete
         * @apiGroup Certifications
         * @apiName delete
         * @apiDescription Delete the given certification. This is a hard delete.
         * @apiParam {Number} certification_id
         * @apiExample {js} Example:
         *             gigwalk.certifications.delete({...})
         */
        value: function _delete(params) {
            return this.client.delete('/v1/certifications/' + params.certification_id);
        }

        /**
         * @api {get} /v1/certifications/:certification_id get
         * @apiGroup Certifications
         * @apiName get
         * @apiDescription Get certification information.
         * @apiParam {Number} certification_id
         * @apiExample {js} Example:
         *             gigwalk.certifications.get({...})
         */

    }, {
        key: 'get',
        value: function get(params) {
            return this.client.get('/v1/certifications/' + params.certification_id);
        }

        /**
         * @api {put} /v1/certifications/:certification_id update
         * @apiGroup Certifications
         * @apiName update
         * @apiDescription Update certification(s).
         * @apiParam {Number} certification_id
         * @apiParam {Object} certification
         * @apiExample {js} Example:
         *             gigwalk.certifications.update({...})
         */

    }, {
        key: 'update',
        value: function update(params) {
            return this.client.put('/v1/certifications/' + params.certification_id, (0, _extends3.default)({}, params.certification));
        }

        /**
         * @api {get} /v1/certifications getAll
         * @apiGroup Certifications
         * @apiName getAll
         * @apiDescription Get all certifications available to the current user. Returns the current user organization's certificates and public certificates.
                           Capable of returning paginated results.
         * @apiParam {Object} [query]
         * @apiExample {js} Example:
         *             gigwalk.certifications.getAll({...})
         */

    }, {
        key: 'getAll',
        value: function getAll(params) {
            var query = params ? this.stringForQueryObject(params.query) : '';

            return this.client.get('/v1/certifications' + query);
        }

        /**
         * @api {post} /v1/certifications create
         * @apiGroup Certifications
         * @apiName create
         * @apiDescription Create certification(s). If the certification already exists (checked by title), then existing certification(s) returned.
         * @apiParam {Object[]} certifications
         * @apiExample {js} Example:
         *             gigwalk.certifications.create({...})
         */

    }, {
        key: 'create',
        value: function create(params) {
            var data = {
                certifications: params.certifications
            };

            return this.client.post('/v1/certifications', data);
        }

        /**
         * @api {get} /v1/organizations/:organization_id/customer/:customer_id/certifications getAllForCustomer
         * @apiGroup Certifications
         * @apiName getAllForCustomer
         * @apiDescription Get certification information for a given customer. Capable of returning paginated results.
         * @apiParam {Number} organization_id
         * @apiParam {Number} customer_id
         * @apiParam {Object} [query]
         * @apiExample {js} Example:
         *             gigwalk.certifications.getAllForCustomer({...})
         */

    }, {
        key: 'getAllForCustomer',
        value: function getAllForCustomer(params) {
            var query = this.stringForQueryObject(params.query);

            return this.client.get('/v1/organizations/' + params.organization_id + '/customer/' + params.customer_id + '/certifications' + query);
        }

        /**
         * @api {put} /v1/organizations/:organization_id/customer/:customer_id/certifications addToCustomer
         * @apiGroup Certifications
         * @apiName addToCustomer
         * @apiDescription Add certifications to a customer. A WORKER can use this endpoint only to add/remove SELF_CERTS certifications to themselves.
         * @apiParam {Number} organization_id
         * @apiParam {Number} customer_id
         * @apiParam {Number[]} certification_ids
         * @apiExample {js} Example:
         *             gigwalk.certifications.addToCustomer({...})
         */

    }, {
        key: 'addToCustomer',
        value: function addToCustomer(params) {
            var data = {
                action: 'add',
                certification_ids: params.certification_ids
            };

            return this.client.put('/v1/organizations/' + params.organization_id + '/customer/' + params.customer_id + '/certifications', data);
        }

        /**
         * @api {put} /v1/organizations/:organization_id/customer/:customer_id/certifications removeFromCustomer
         * @apiGroup Certifications
         * @apiName removeFromCustomer
         * @apiDescription Remove certifications from a customer. A WORKER can use this endpoint only to add/remove SELF_CERTS certifications to themselves.
         * @apiParam {Number} organization_id
         * @apiParam {Number} customer_id
         * @apiParam {Number[]} certification_ids
         * @apiExample {js} Example:
         *             gigwalk.certifications.removeFromCustomer({...})
         */

    }, {
        key: 'removeFromCustomer',
        value: function removeFromCustomer(params) {
            var data = {
                action: 'remove',
                certification_ids: params.certification_ids
            };

            return this.client.put('/v1/organizations/' + params.organization_id + '/customer/' + params.customer_id + '/certifications', data);
        }

        /**
         * @api {get} /v1/organizations/:organization_id/certifications getAllForOrganization
         * @apiGroup Certifications
         * @apiName getAllForOrganization
         * @apiDescription Get certifications information for a given organization. Capable of returning paginated results.
         * @apiParam {Number} organization_id
         * @apiParam {Object} [query]
         * @apiExample {js} Example:
         *             gigwalk.certifications.getAllForOrganization({...})
         */

    }, {
        key: 'getAllForOrganization',
        value: function getAllForOrganization(params) {
            var query = this.stringForQueryObject(params.query);

            return this.client.get('/v1/organizations/' + params.organization_id + '/certifications' + query);
        }

        /**
         * @api {post} /v1/organizations/:organization_id/certifications createForOrganization
         * @apiGroup Certifications
         * @apiName createForOrganization
         * @apiDescription Create certification(s) for a given organization. If the certification already exists (checked by title), then existing
                           certification(s) returned.
         * @apiParam {Number} organization_id
         * @apiParam {Object[]} certifications
         * @apiExample {js} Example:
         *             gigwalk.certifications.createForOrganization({...})
         */

    }, {
        key: 'createForOrganization',
        value: function createForOrganization(params) {
            var data = {
                certifications: params.certifications
            };

            return this.client.post('/v1/organizations/' + params.organization_id + '/certifications', data);
        }

        /**
         * @api {put} /v1/organizations/:organization_id/certifications updateForOrganization
         * @apiGroup Certifications
         * @apiName updateForOrganization
         * @apiDescription Create certification(s) for a given organization. If the certification already exists (checked by title), then existing
                           certification(s) returned.
         * @apiParam {Number} organization_id
         * @apiParam {Object[]} certifications
         * @apiExample {js} Example:
         *             gigwalk.certifications.updateForOrganization({...})
         */

    }, {
        key: 'updateForOrganization',
        value: function updateForOrganization(params) {
            var data = {
                certifications: params.certifications
            };

            return this.client.put('/v1/organizations/' + params.organization_id + '/certifications', data);
        }

        /**
         * @api {post} /v1/organizations/:organization_id/certifications/delete deleteForOrganization
         * @apiGroup Certifications
         * @apiName deleteForOrganization
         * @apiDescription Mark the certification(s) with the passed ids as deleted.
         * @apiParam {Number} organization_id
         * @apiParam {Number[]} certification_ids
         * @apiExample {js} Example:
         *             gigwalk.certifications.deleteForOrganization({...})
         */

    }, {
        key: 'deleteForOrganization',
        value: function deleteForOrganization(params) {
            var data = {
                certification_ids: params.certification_ids
            };

            return this.client.post('/v1/organizations/' + params.organization_id + '/certifications/delete', data);
        }

        /**
         * @api {post} /v1/organizations/:organization_id/certifications/upload uploadForOrganization
         * @apiGroup Certifications
         * @apiName uploadForOrganization
         * @apiDescription Create certifications from a file that has been uploaded to S3.
                           See https://docs.google.com/document/d/1Q14OKBva_2VhWdSQCbrwjq2Q8dVH6TwXgZ83jTGxHRc/ for more information about our file upload api.
         * @apiParam {Number} organization_id
         * @apiParam {String[]} s3_keys
         * @apiExample {js} Example:
         *             gigwalk.certifications.uploadForOrganization({...})
         */

    }, {
        key: 'uploadForOrganization',
        value: function uploadForOrganization(params) {
            var data = {
                s3_keys: params.s3_keys
            };

            return this.client.post('/v1/organizations/' + params.organization_id + '/certifications/upload', data);
        }
    }]);
    return Certifications;
}(_resource2.default);

exports.default = Certifications;
//# sourceMappingURL=index.js.map